import { buildModule } from '../utils';

import lazy from './lazy';
import categories from './categories';
import classes from './classes';
import customFields from './custom-fields';
import detail from './detail';

export default buildModule()
	.withSubmodules({
		lazy,
		categories,
		classes,
		customFields,
		detail,
	});
